import * as types from '../constants/ActionTypes';
import client from '../lib/frost-web-client';
import logout from '../lib/logout';

export function requestReport() {
	return { type: types.REQUEST_REPORT };
}

export function receiveReport(data) {
	return { type: types.RECEIVE_REPORT, data };
}

export function receiveReportError(error) {
	return { type: types.RECEIVE_REPORT_ERROR, error };
}

export function fetchReport(type, customerIds) {

	return dispatch => {

		dispatch(requestReport());

		return client.post(`/api/reports/${encodeURIComponent(type)}`, { customerIds })
			.then(response => dispatch(receiveReport(response.text)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveReportError(error.response));
				}
			});

	};

}



// WEBPACK FOOTER //
// ./src/assets/js/actions/reports.js